import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AllCategory from '../question/category/QuestionCategory'
import GlobalQuestion from '../question/global/GlobalQuestion'
import AddQuestion from '../question/global/AddQuestion'
import UpdateQuestion from '../question/global/UpdateQuestion'

function QuestionRoute() {
  return (
    <>
      <Routes>
        <Route path='/question-category' element={<AllCategory/>}/>

        <Route path='/global-question' element={<GlobalQuestion/>}/>
        <Route path='/add-question' element={<AddQuestion/>}/>
        <Route path='/update-question' element={<UpdateQuestion
        />}/>
      </Routes>
    </>
  )
}

export default QuestionRoute
